import { createAsyncThunk } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../client';
import { NetworkLandingPageVideoResponse } from './interface';


export const getNetworkLandingPageVideos = createAsyncThunk(
  'networkLandingPageVideo/getNetworkLandingPageVideos',
  async (_,
    { rejectWithValue }
  ) => {
    try {
      const response = await axiosInstance.get<NetworkLandingPageVideoResponse>(
        `/api/network-landing-page-videos`

      );
      return response;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);


